import { Component } from '@angular/core';


export class SkyAlertDemoComponent {
  public closeable = true;
  public closed = false;
  public alertType = 'warning';

  public openAlert() {
    this.closed = false;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-alert-demo',
  template: `<sky-alert
  [alertType]="alertType"
  [closeable]="closeable"
  [closed]="closed">
  This is a sample alert.
</sky-alert>
<select [(ngModel)]="alertType">
  <option value="info">info</option>
  <option value="success">success</option>
  <option value="warning">warning</option>
  <option value="danger">danger</option>
</select>
<sky-checkbox [(ngModel)]="closeable">
  <sky-checkbox-label>Closeable</sky-checkbox-label>
</sky-checkbox>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
